<div [class.border]="withBorder()" class="p-4 rounded-lg bg-white dark:bg-gray-800 shadow-md">
  <ui-label [tag]="ELabelType.SECTION_TITLE">{{name()}}</ui-label>
  <br>
  <div [ngClass]="!inList() ? 'grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 items-center' : 'grid grid-cols-1'">
    <div #container class="hidden">
    </div>
  </div>

</div>
